export const IS_MOBILE = "(max-width: 767px)";
export const IS_TABLET = "(max-width: 1239px)";
export const IS_TABLET_ONLY = "(min-width: 768px) and (max-width: 1239px)";
export const IS_NOTEBOOK = "(min-width: 1024px) and (max-width: 1239px)";
export const IS_DESKTOP = "(min-width: 1240px) and (max-width: 1919px)";
export const IS_DESKTOP_UP = "(min-width: 1240px)";
export const IS_DESKTOP_LARGE = "(min-width: 1920px)";
